<template>
  <div class="credential-wrap">
    <back-button :tag="false" />
    <van-grid :column-num="2" :gutter="20" :border="false">
      <van-grid-item @click="goDetail(1)" class="border-box">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-1.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-1.png"
            alt="竞赛达人"
          />
        </picture>
        <div v-if="Object.keys(jingsaidaren).length > 0">
          <img
            v-if="Number(jingsaidaren.target) > Number(jingsaidaren.num)"
            src="@/assets/img/honor/no.png"
            class="item-btn"
          />
          <img v-else src="@/assets/img/honor/yes.png" class="item-btn" />
        </div>
      </van-grid-item>
      <van-grid-item @click="goDetail(2)" class="border-box">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-2.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-2.png"
            alt="十级学者"
          />
        </picture>
        <div v-if="Object.keys(shijixuezhe).length > 0">
          <img
            v-if="Number(shijixuezhe.target) > Number(shijixuezhe.num)"
            src="@/assets/img/honor/no.png"
            class="item-btn"
          />
          <img v-else src="@/assets/img/honor/yes.png" class="item-btn" />
        </div>
      </van-grid-item>
      <van-grid-item @click="goDetail(3)" class="border-box">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-3.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-3.png"
            alt="答题大王"
          />
        </picture>

        <div v-if="Object.keys(datidawang).length > 0">
          <img
            v-if="Number(datidawang.target) > Number(datidawang.num)"
            src="@/assets/img/honor/no.png"
            class="item-btn"
          />
          <img v-else src="@/assets/img/honor/yes.png" class="item-btn" />
        </div>
      </van-grid-item>
      <van-grid-item @click="goDetail(4)" class="border-box">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-4.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-4.png"
            alt="知识猎手"
          />
        </picture>

        <div v-if="Object.keys(zhishilieshou).length > 0">
          <img
            v-if="Number(zhishilieshou.target) > Number(zhishilieshou.num)"
            src="@/assets/img/honor/no.png"
            class="item-btn"
          />
          <img v-else src="@/assets/img/honor/yes.png" class="item-btn" />
        </div>
      </van-grid-item>
      <van-grid-item @click="goDetail(5)" class="border-box">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-5.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-5.png"
            alt="常胜将军"
          />
        </picture>
        <div v-if="Object.keys(changshengjiangjiu).length > 0">
          <img
            v-if="
              Number(changshengjiangjiu.target) > Number(changshengjiangjiu.num)
            "
            src="@/assets/img/honor/no.png"
            class="item-btn"
          />
          <img v-else src="@/assets/img/honor/yes.png" class="item-btn" />
        </div>
      </van-grid-item>
      <van-grid-item @click="goDetail(6)" class="border-box">
        <picture>
          <source
            srcset="@/assets/img/honor/certificate-6.png"
            type="image/png"
          />
          <img
            class="icon"
            src="@/assets/img/honor/certificate-6.png"
            alt="学习标兵"
          />
        </picture>
        <div v-if="Object.keys(xuexibiaobing).length > 0">
          <img
            v-if="Number(xuexibiaobing.target) > Number(xuexibiaobing.num)"
            src="@/assets/img/honor/no.png"
            class="item-btn"
          />
          <img v-else src="@/assets/img/honor/yes.png" class="item-btn" />
        </div>
        <!-- <van-button
          v-if="Object.keys(xuexibiaobing).length > 0"
          class="item-btn"
          color="linear-gradient(to right, #147EE6, #2C62FE)"
          round
          :disabled="Number(xuexibiaobing.target) > Number(xuexibiaobing.num)"
          >{{
            Number(xuexibiaobing.target) > Number(xuexibiaobing.num)
              ? "未解锁"
              : "已解锁"
          }}</van-button
        > -->
      </van-grid-item>
    </van-grid>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
  data() {
    return {
      xuexibiaobing: {},
      changshengjiangjiu: {},
      datidawang: {},
      jingsaidaren: {},
      shijixuezhe: {},
      zhishilieshou: {},
    };
  },
  methods: {
    async getList() {
      try {
        const res = await this.$axios.post(`/Statis/getMedal`);
        const {
          xuexibiaobing,
          changshengjiangjiu,
          datidawang,
          jingsaidaren,
          shijixuezhe,
          zhishilieshou,
        } = res?.data ?? {};
        this.xuexibiaobing = xuexibiaobing;
        this.changshengjiangjiu = changshengjiangjiu;
        this.datidawang = datidawang;
        this.jingsaidaren = jingsaidaren;
        this.shijixuezhe = shijixuezhe;
        this.zhishilieshou = zhishilieshou;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.msg || "获取证书错误",
          duration: 2000,
        });
        console.log(error);
      } finally {
        this.$toast.clear();
      }
    },
    goDetail(type) {
      switch (type) {
        case 1:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.jingsaidaren.num}&target=${this.jingsaidaren.target}&date=${this.jingsaidaren.date}`
          );
          break;
        case 2:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.shijixuezhe.num}&target=${this.shijixuezhe.target}&date=${this.shijixuezhe.date}`
          );
          break;
        case 3:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.datidawang.num}&target=${this.datidawang.target}&date=${this.datidawang.date}`
          );
          break;
        case 4:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.zhishilieshou.num}&target=${this.zhishilieshou.target}&date=${this.zhishilieshou.date}`
          );
          break;
        case 5:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.changshengjiangjiu.num}&target=${this.changshengjiangjiu.target}&date=${this.changshengjiangjiu.date}`
          );
          break;
        case 6:
          this.$router.push(
            `/credential/detail?type=${type}&num=${this.xuexibiaobing.num}&target=${this.xuexibiaobing.target}&date=${this.xuexibiaobing.date}`
          );
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.credential-wrap {
  @include index-bg;

  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 0 22px 28px;
  overflow: hidden;

  .van-grid {
    .van-grid-item {
      position: relative;
      margin-top: 24px;
      cursor: pointer;
      .item-btn {
        width: 82px;
        height: 23px;
        margin-top: 14px;
      }
    }
    .border-box {
      ::v-deep .van-grid-item__content {
        background: url("~@/assets/img/honor/boder-box.png") no-repeat center
          center;
        background-size: 100% 100%;
      }
    }

    .icon {
      width: 103px;
      height: 105px;
      vertical-align: middle;
    }
  }
}
</style>
